import React, {Fragment, useState, useEffect} from 'react';
import 'fontsource-roboto';
import {createMuiTheme, makeStyles, ThemeProvider} from '@material-ui/core/styles';
import {BrowserRouter, Switch, Route, Link} from 'react-router-dom';
import './Utils';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Badge from '@material-ui/core/Badge';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Snackbar from '@material-ui/core/Snackbar';
import LinearProgress from '@material-ui/core/LinearProgress';

import Alert from '@material-ui/lab/Alert';

import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import SettingsIcon from '@material-ui/icons/Settings';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ExtensionIcon from '@material-ui/icons/Extension';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import ViewListIcon from '@material-ui/icons/ViewList';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import ListAltIcon from '@material-ui/icons/ListAlt';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import MailIcon from '@material-ui/icons/Mail';
import DescriptionIcon from '@material-ui/icons/Description';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MenuIcon from '@material-ui/icons/Menu';

import Login from './Views/Login';
import RouterView from './Components/RouterView';

const theme = createMuiTheme({
  // palette: {
  //   primary: {
  //     main: 'rgb(245, 169, 32)',
  //     contrastText: 'rgba(255, 255, 255, 0.87)'
  //   },
  //   secondary: {
  //     main: 'rgb(231, 59, 45)',
  //     contrastText: 'rgba(255, 255, 255, 0.87)'
  //   }
  // },
  props: {
    MuiAutocomplete: {
      fullWidth: true
    },
    MuiButton: {
      size: 'small'
    },
    MuiContainer: {
      disableGutters: true,
      fixed: true
    },
    MuiListItem: {
      divider: true
    },
    MuiFab: {
      color: 'primary'
    },
    MuiTextField: {
      fullWidth: true,
      size: 'small',
      variant: 'filled'
    },
    MuiTypography: {
      variant: 'body2'
    }
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        html: {
          boxSizing: 'border-box'
        }
      }
    },
    MuiSvgIcon: {
      root: {
        verticalAlign: 'bottom'
      }
    },
    // MuiTouchRipple: {
    //   child: {
    //     backgroundColor: 'rgb(245, 169, 32)'
    //   }
    // }
  }
});

const useStyles = makeStyles(() => ({
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  menu: {
    width: '240px'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }
}));

const mainMenus = [
  {category: 'Main'          , caption: 'Receptie'           , linkTo: '/Dashboard'        , icon: <DashboardIcon />                                                    },
  {category: 'Receptions'    , caption: 'Recoltari'          , linkTo: '/Receptions'       , icon: <ExtensionIcon />     , requiredPermission: 'partnerLab'             },
  {category: 'Receptions'    , caption: 'Recoltari'          , linkTo: '/Receptions'       , icon: <ExtensionIcon />     , requiredPermission: 'partnerReceptions'      },
  {category: 'Receptions'    , caption: 'Pacienti'           , linkTo: '/Patients'         , icon: <PeopleAltIcon />     , requiredPermission: 'partnerReceptions'      },
  {category: 'Receptions'    , caption: 'Rezultate'          , linkTo: '/Results'          , icon: <DoneAllIcon />       , requiredPermission: 'partnerReceptions'      },
  {category: 'Receptions'    , caption: 'Servicii'           , linkTo: '/ResellerServices' , icon: <ViewListIcon />      , requiredPermission: 'partnerReceptions'      },
  {category: 'Receptions'    , caption: 'Consumabile'        , linkTo: '/Consumables'      , icon: <BusinessCenterIcon />, requiredPermission: 'partnerLab'             },
  {category: 'Receptions'    , caption: 'Consumabile'        , linkTo: '/Consumables'      , icon: <BusinessCenterIcon />, requiredPermission: 'partnerReceptions'      },
  {category: 'MedicalRecords', caption: 'Fise auto'          , linkTo: '/MedicalRecords'   , icon: <ListAltIcon />       , requiredPermission: 'partnerMedicalRecords'  },
  {category: 'Intern'        , caption: 'Laboratoare externe', linkTo: '/ExternLabs'       , icon: <LocalHospitalIcon /> , requiredPermission: 'partnerExternLabs'      },
  {category: 'Intern'        , caption: 'Scrisori COVID-19'  , linkTo: '/CovidLetters'     , icon: <MailIcon />          , requiredPermission: 'partnerCovidLetters'    },
  {category: 'Documents'     , caption: 'Formulare'          , linkTo: '/Documents'        , icon: <DescriptionIcon />   , requiredPermission: 'partnerLab'             },
  {category: 'Documents'     , caption: 'Formulare'          , linkTo: '/Documents'        , icon: <DescriptionIcon />   , requiredPermission: 'partnerReceptions'      }
];

const adminMenu = [
  {category: 'All'  , caption: 'Contul meu'                    , linkTo: '/MyAccount'                                      },
  {category: 'Admin', caption: 'Parteneri si categorii de pret', linkTo: '/Partners'   , requiredPermission: 'partnerAdmin'},
  {category: 'Admin', caption: 'Utilizatori'                   , linkTo: '/Users'      , requiredPermission: 'partnerAdmin'},
  {category: 'Admin', caption: 'Permisiuni aplicatie'          , linkTo: '/Permissions', requiredPermission: 'partnerAdmin'},
  {category: 'Admin', caption: 'Registre'                      , linkTo: '/Registers'  , requiredPermission: 'partnerAdmin'},
  {category: 'Admin', caption: 'Servicii'                      , linkTo: '/Services'   , requiredPermission: 'partnerAdmin'},
  {category: 'Test' , caption: 'Nu apasa ca o incurci!'        , linkTo: '/Test'       , requiredPermission: 'partnerAdmin'}
];

export default function App(props) {
  const classes = useStyles();

  const [user, setUser] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [notifications, setNotifications] = useState(null);
  const [notificationsAnchorEl, setNotificationsAnchorEl] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // used for ajax calls
  const [error, setError] = useState({
    ok: null,
    error: null
  });

  const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

  useEffect(() => {
    if (localStorage.getObject('user')) {
      ajax('login', {
        username: localStorage.getObject('user').username
      })
        .then(response => {
          if (response.ok) {
            localStorage.setObject('user', response.data);
            setUser(response.data);
          }
        });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    var interval = null;

    if (!user) {
      clearInterval(interval);
      setNotifications(null);
      return;
    }

    interval = setInterval(function dummy() {
      ajax('getNotifications')
        .then(response => {
          if (Boolean(response.data))
            setNotifications(response.data);
        });
      return dummy;
    }(), 30000);

    return () => clearInterval(interval);
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  const ajax = async (op, data = {}, files = []) => {
    setIsLoading(true);
    const sid = localStorage.getObject('user') ? localStorage.getObject('user').sessid : null;
    data.op = op;
    var formData = new FormData();
    formData.append('j_data', JSON.stringify(data));
    files.forEach(file => formData.append(file.paramName, file.file));
    return await fetch(`${props.url.api}?op=${op}&______________${sid ? `&SID=${sid}` : ''}&variant=live`, {
    // return await fetch(`${props.url.api}?op=${op}&______________${sid ? `&SID=${sid}` : ''}`, {
      method: 'POST',
      cache: 'no-cache',
      credentials: 'same-origin',
      redirect: 'follow',
      referrer: 'no-referrer',
      body: formData
    })
      .then(response => response.json())
      .then(response => {
        setIsLoading(false);

        if (!Boolean(response))
          throw new Error(`AJAX failed, response is not an object! response is of type '${typeof response}' and its value is '${response}'`);

        setError({
          ok: response.ok,
          error: response.error
        });

        return response;
      })
      .then(response => {
        if (Boolean(response.attachments?.length)) {
          function base64ToArrayBuffer(base64) {
            var binaryString =  window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (let i = 0; i < binaryLen; i++)        {
              var ascii = binaryString.charCodeAt(i);
              bytes[i] = ascii;
            }
            return bytes;
          }

          var saveByteArray = (function () {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            return function (data, contentType, name) {
              var blob = new Blob(data, {type: contentType});
              var url = window.URL.createObjectURL(blob);
              a.href = url;
              a.download = name;
              a.click();
              window.URL.revokeObjectURL(url);
              a.remove();
            };
          }());

          response.attachments.forEach(attachment => {
            saveByteArray([base64ToArrayBuffer(attachment.data)], attachment.contentType, attachment.fileName);
          });
        }

        return response;
      })
      .catch(err => {
        setIsLoading(false);
        setError({
          ok: false,
          error: 'Comunicarea cu serverul a esuat'
        });
        console.error('Eroare: Comunicarea cu serverul a esuat cu urmatorul mesaj:\n', err);
      });
  };

  const filterMenu = menu => typeof menu.requiredPermission === 'undefined' || !!~user.permissions.indexOf(menu.requiredPermission);

  const toggleDrawer = (open) => e => {
    if (e && e.type === 'keydown' && (e.key === 'Tab' || e.key === 'Shift'))
      return;

    setMenuOpen(open);
  };

  const handleError = (errorMessage) => {
    setError({
      ok: false,
      error: errorMessage
    });
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth='lg'>
          <BrowserRouter>
            {user
              ? <Fragment>
                  <AppBar position='fixed'>
                    <Toolbar variant='dense'>
                      <IconButton edge='start' className={classes.menuButton} color='inherit' onClick={toggleDrawer(true)}>
                        <MenuIcon />
                      </IconButton>
                      <Box className={classes.title}>
                        <Typography variant='h6'>Sunmed Tulcea</Typography>
                      </Box>
                      <Box>
                        {!Boolean(user.idPartner) && Boolean(notifications) && Boolean(Object.keys(notifications).length) &&
                          <IconButton color='inherit'
                            onClick={e => setNotificationsAnchorEl(e.currentTarget)}
                          >
                            <Badge badgeContent={Object.keys(notifications).length} color='secondary'>
                              <NotificationsActiveIcon />
                            </Badge>
                          </IconButton>
                        }
                        <Menu keepMounted
                          anchorEl={notificationsAnchorEl}
                          anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                          }}
                          open={Boolean(notificationsAnchorEl)}
                          onClose={() => setNotificationsAnchorEl(null)}
                        >
                          {Boolean(notifications) && Boolean(Object.keys(notifications).length) && Object.keys(notifications).map(key =>
                            <Link key={key} to={notifications[key].link} className={classes.link}>
                              <MenuItem onClick={() => setNotificationsAnchorEl(null)}>{notifications[key].message}</MenuItem>
                            </Link>
                          )}
                        </Menu>

                        <IconButton color='inherit'
                          onClick={e => setAnchorEl(e.currentTarget)}
                        >
                          <SettingsIcon />
                        </IconButton>
                        <Menu keepMounted
                          anchorEl={anchorEl}
                          anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                          }}
                          open={Boolean(anchorEl)}
                          onClose={() => setAnchorEl(null)}
                        >
                          {adminMenu.filter(filterMenu).map((menu, i) =>
                            <Link key={menu.linkTo} to={menu.linkTo} className={classes.link}>
                              <ListItem button style={{paddingTop: '4px', paddingBottom: '4px'}}
                                divider={i < adminMenu.filter(filterMenu).length - 1 && menu.category !== adminMenu.filter(filterMenu)[i + 1].category}
                                onClick={() => setAnchorEl(null)}
                              >
                                <ListItemText primary={menu.caption} />
                              </ListItem>
                            </Link>
                          )}
                        </Menu>
                      </Box>
                    </Toolbar>
                  </AppBar>

                  <SwipeableDrawer disableBackdropTransition={!iOS} disableDiscovery={iOS}
                    open={menuOpen}
                    onClose={toggleDrawer(false)}
                    onOpen={toggleDrawer(true)}
                  >
                    <Box className={classes.menu}
                      onClick={toggleDrawer(false)}
                      onKeyDown={toggleDrawer(false)}
                    >
                      <List disablePadding>
                        <Link to='/MyAccount' className={classes.link}>
                          <ListItem button divider>
                            <ListItemIcon><AccountCircleIcon /></ListItemIcon>
                            <ListItemText
                              primary={user.nume}
                              secondary={user.partner}
                            />
                          </ListItem>
                        </Link>
                        {mainMenus.filter(filterMenu).map((menu, i) =>
                          <Link key={menu.linkTo} to={menu.linkTo} className={classes.link}>
                            <ListItem button
                              divider={i === mainMenus.filter(filterMenu).length - 1 || menu.category !== mainMenus.filter(filterMenu)[i + 1].category}
                            >
                              <ListItemIcon>{menu.icon}</ListItemIcon>
                              <ListItemText primary={menu.caption} />
                            </ListItem>
                          </Link>
                        )}
                        <ListItem button onClick={handleLogout}>
                          <ListItemIcon><ExitToAppIcon /></ListItemIcon>
                          <ListItemText primary='Deconectare' />
                        </ListItem>
                        <ListItem divider={false}>
                          <ListItemText
                            primary={<Typography align='center'>Copyright &copy; {`2018-${new Date().getFullYear()}`}</Typography>}
                            secondary={<Typography align='center'>Integrated Software SRL</Typography>}
                          />
                        </ListItem>
                      </List>
                    </Box>
                  </SwipeableDrawer>

                  <RouterView {...props} ajax={ajax} isLoading={isLoading} error={handleError} user={user} />
                </Fragment>
              : <Switch>
                  <Route exact path='/Login' render={(props) => <Login {...props} ajax={ajax} isLoading={isLoading} setUser={setUser} />}></Route>
                  <Route render={(props) => <Login {...props} ajax={ajax} isLoading={isLoading} setUser={setUser} />}></Route>
                </Switch>
            }

            <Snackbar open={isLoading}>
              <LinearProgress color='secondary' style={{width: '100%'}} />
            </Snackbar>

            <Snackbar autoHideDuration={10000} style={{bottom: '80px', minWidth: '320px'}}
              open={!Boolean(error.ok) && error.error !== null}
              onClose={() => setError({ok: null, error: null})}
            >
              <Alert elevation={6} variant='filled'
                severity={error.ok ? 'success' : 'error'} // error | info | success | warning
                // onClose={() => setError({ok: null, error: null})}
              >
                {error.error}
              </Alert>
            </Snackbar>
          </BrowserRouter>
      </Container>
    </ThemeProvider>
  );
}